<template>
<div id="groom">
    <div class="btn_wrap">
        <div class="list_05_select w100" >
            <div class="list_05_btn" @click="map_group_sel_pop = true">
                <span>{{sel_group_name}}</span><font-awesome-icon :icon="['fas', 'sort-down']" />
            </div>
        </div>
    </div>
    <div class="list_05_select_pop_wrap" v-if="map_group_sel_pop">
        <div class="list_05_select_pop">
            <ul>
                <li v-for="(item,index) in groom_list" :key="index" :id="item.groom_id" @click="select_groom(item)" :class="item.class">{{item.tab_name}} - {{item.groom_name}}</li>
            </ul>
        </div>
    </div>

    <p class="clear"></p>
    <img class="tit-img-point" src="../../assets/image/groom-pop-icon1.png"><p class="tit01" style="display:inline-block;">그룹룸 정보</p>
    <div class="table-wrapper">
        <table class="table01">
            <colgroup>
                <col width="30%;" />
                <col width="70%;" />
            </colgroup>
            <tr>
                <th>이름</th>
                <td>{{groom_name}} <span v-if="type_name.length > 0">({{type_name}})</span></td>
            </tr>
            <tr>
                <th>좌석수</th>
                <td class="groom_seat">{{groom_seat_count}}</td>
            </tr>
            <tr>
                <th>정보</th>
                <td style='border: none !important;' class="groom-info hidden-scroll" colspan="3" v-html="groom_info"></td>
            </tr>
        </table>
    </div>
    <img class="tit-img-point" src="../../assets/image/groom-pop-icon2.png"><p class="tit01" style="display:inline-block;">당일 사용/예약 현황</p>

    <div class="table-wrapper">
        <table class="table01_a center">
            <colgroup>
            <col width="10%;" />
            <col width="20%;" />
            <col width="28%;" />
            <col width="28%;" />
            <col width="14%;" />
            </colgroup>
            <thead>
                <tr>
                    <th>번호</th>
                    <th>이용상품</th>
                    <th>시작시간</th>
                    <th>종료시간</th>
                    <th>상태</th>
                </tr>
            </thead>
        </table>
        <div class="scroll-area hidden-scroll">
            <table class="table02 table-body">
                <colgroup>
                <col width="10%;" />
                <col width="20%;" />
                <col width="28%;" />
                <col width="28%;" />
                <col width="14%;" />
                </colgroup>
                <tbody>
                    <template v-if="today_groom_reserv_list.length !== 0 || today_groom_using_list.length !== 0">
                        <tr v-for="(items, index) in today_groom_using_list" :key="index+'grooms_using'">
                            <td>{{index + 1}}</td>
                            <td>{{items.goods_group_name}}</td>
                            <td>{{convertDate(items.use_start_datetime)}}<span class="time"> {{convertTime(items.use_start_datetime)}}</span></td>
                            <td>{{convertDate(items.use_end_datetime)}}<span class="time"> {{convertTime(items.use_end_datetime)}}</span></td>
                            <td>{{items.name}}</td>
                        </tr>
                        <tr v-for="(item, index) in today_groom_reserv_list" :key="index+'grooms'">
                            <td>{{today_groom_reserv_list.index + index + 1}}</td>
                            <td>{{item.goods_group_name}}</td>
                            <td>{{convertDate(item.use_start_datetime)}}<span class="time"> {{convertTime(item.use_start_datetime)}}</span></td>
                            <td>{{convertDate(item.end_datetime)}}<span class="time"> {{convertTime(item.end_datetime)}}</span></td>
                            <td>{{item.code_name}}</td>
                        </tr>
                    </template>
                    <tr v-if="groom_name !== '' && today_groom_reserv_list.length === 0 && today_groom_using_list.length !== 0">
                        <td colspan="5" align="center">당일 예약 현황이 존재하지 않습니다.</td>
                    </tr>
                    <tr v-if="groom_name !== '' && today_groom_reserv_list.length === 0 && today_groom_using_list.length === 0">
                        <td colspan="5" align="center">당일 예약/사용 현황이 존재하지 않습니다.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="bottom_btn02" v-if="store_pay_yn">
        <a @click="start_immediately"><div class="btn_01 btn-ok">즉시사용</div></a>
        <a @click="groom_reservation"><div class="btn_01 btn-ok">예약</div></a>
        <!-- <a href="#" @click="purchase_groomProduct"><div class="btn_03">상품구매</div></a> -->
    </div>
</div>
</template>

<script>
import EventBus from "./EventBus";
import * as config from '../../javascript/config';
export default {
    name: 'groom',
    data() {
        return {
            groom_all_list: [],
            groom_list: [],
            wid_scroll_left: false,
            wid_scroll_right: false,
            add_step: 0, // 그룹룸 리스트 표현을 위한 step. 값 0 은 groom_all_list 의 0번째 를 뜻함 groom_all_list[0].xxx
            // groom detail
            groom_id: '',
            before_groom_id: '',
            groom_name: '',
            groom_info: '',
            groom_seat_count: '',
            groom_status_code: '',
            groom_type_id: '',
            min_user_count: '',
            today_groom_reserv_list: [], // 당일 예약 현황 리스트
            today_groom_using_list: [], // 당일 사용 현황 리스트
            /// 새로 추가
            type_name : '',
            groom_goods_group_id : '',
            groom_goods_name : '',
            selection_plan_code : '',
            goods_group_name : '',
            store_pay_yn: this.$store.getters['getStore_pay_info'],
            tab_data: Object, // 탭(층) 정보
            tab_name: '',
            map_group_sel_pop: false,
            sel_group_name : '',
            map_group_id: '',
            tab_index: 0,
            groom_limit_now_use: '',
            groom_limit_now_start_time: '',
            groom_limit_now_end_time: '',
            first_loading_groom_count:0,
            groom_reserve_use_yn:'N'
        }
    },
    methods: {
        start_immediately() {
            const type_groom_status_get = config.REQ_GROOM_STATUS_GET;
            if(parseInt(this.groom_id) > 0){
                this.$store.dispatch(type_groom_status_get.action_name, {
                    type: type_groom_status_get,
                    data: {groom_id: this.groom_id}
                }).then(response => {     
                    let sel_groom_status = response.data[0].groom_status_code
                    console.log(this.groom_limit_now_use)
                    if(this.groom_limit_now_use == 'Y'){
                        let check_use_now = true;
                        let today = new Date();
                        let hours = today.getHours();

                        //250710 즉시사용 불가시간 타입이 안 맞아서 시간 비교가 제대로 되고있지 않아 수정함
                        let start = Number(this.groom_limit_now_start_time);
                        let end = Number(this.groom_limit_now_end_time);

                        if(start > end ){
                            if (hours >= start || hours <= end) {
                                check_use_now = false;
                            }
                        }else if(start < end ){
                            if (hours >= start && hours < end) {
                                check_use_now = false;
                            }
                        }

                        if(!check_use_now){
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: `그룹룸 즉시사용이 불가한 시간입니다.`,
                                router: '',
                                image_type: 'warning'
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            return;
                        }
                    }
                    if(sel_groom_status == 'GROOM_LOCK'){
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `해당 그룹룸은 결제중이거나 이미 사용중입니다.`,
                            router: '',
                            image_type: 'warning'
                        };
                        this.$store.commit('set_popup_type', alert_param);
                    }else{
                        // 선택된 탭의 그룹룸 정보 매칭이 안되고 항상 첫번째 그룹룸만 매칭하는 문제로 수정함 2021-03-08
                        for(var i=0; i<this.groom_list.length; i++){
                            if(this.groom_id == this.groom_list[i].groom_id && this.groom_list[i].admin_only == 1){
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: `해당 그룹룸은 예약전용 입니다.<br>관리자에게 문의하세요`,
                                router: '',
                                image_type: 'warning'
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            return;
                            }


                            if(this.groom_id == this.groom_list[i].groom_id && this.groom_list[i].code_name === '사용불가' ) {
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: `현재 사용 할 수 없습니다.`,
                                router: '',
                                image_type: 'warning'
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            return;
                            }
                        }




                        let dirUseCheck = false;
                        const type_groom_list = config.REQ_GROOM_USE_GET;
                        const data = {groom_id: this.groom_id};
                        this.$store.dispatch(type_groom_list.action_name, {
                            type: type_groom_list,
                            data: data
                        }).then(response => {
                            if(response.data[0].use_count === 0){
                                dirUseCheck = true;
                            }

                            if (!this.$store.state.login_chk) {
                                // this.$router.push('/login');
                                if(dirUseCheck){
                                    this.$store.commit('set_Last_URL', '/payment-group_room');
                                }else{
                                    this.$store.commit('change_main_tab_chk', {
                                        value: 2
                                    });
                                }
                            } else {
                                if(dirUseCheck){
                                    this.$router.push('/payment-group_room');
                                }else{
                                    const alert_param = {
                                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                        message: `선택하신 그룹룸은 현재 사용중입니다.`,
                                        router: '',
                                    };
                                    this.$store.commit('set_popup_type', alert_param);
                                    return;
                                }
                            }
                        }).catch(function (error) {
                            console.log('error=============>', error);
                        });

                        if (this.groom_id.length == 0) {
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: `그룹룸을 선택해 주세요.`,
                                router: '',
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            return;
                        }

                        this.$store.commit('set_select_groom', {
                            groom_id: this.groom_id,
                            groom_name: this.groom_name,
                            groom_type_id: this.groom_type_id,
                            groom_seat_count: this.groom_seat_count,
                            min_user_count: this.min_user_count,
                            type_name : this.type_name,
                            groom_goods_group_id: this.groom_goods_group_id,
                            groom_goods_name: this.groom_goods_name,
                            selection_plan_code: this.selection_plan_code,
                            goods_group_name: this.goods_group_name,
                        });
                        var groom_info = {};
                            groom_info.groom_id = this.groom_id;
                            groom_info.before_groom_id = this.groom_id;
                            groom_info.groom_status_code = this.groom_status_code;
                            groom_info.groom_name = this.groom_name;
                            groom_info.groom_info = this.groom_info;
                            groom_info.groom_seat_count = this.groom_seat_count;
                            groom_info.groom_type_id = this.groom_type_id;
                            groom_info.min_user_count = this.min_user_count;
                            groom_info.type_name = this.type_name;
                            groom_info.groom_goods_group_id = this.groom_goods_group_id;
                            groom_info.groom_goods_name = this.groom_goods_name;
                            groom_info.selection_plan_code = this.selection_plan_code;
                            groom_info.goods_group_name = this.goods_group_name;
                        this.$store.commit('set_main_page_tab_code', {
                            'tab_code': 'GROOM',
                            'groom_info': groom_info
                        });
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }
          

        },
        purchase_groomProduct() {
            this.$store.state.from_groom = true;
            this.$router.push('/price_list');
        },
        groom_reservation() {
            // 그룹룸 예약 불가 매장인 경우
            if(this.groom_reserve_use_yn == "Y"){
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `그룹룸 예약이 불가능합니다.<br>즉시사용을 이용해주세요.`,
                    router: '',
                    image_type: 'warning'
                };
                this.$store.commit('set_popup_type', alert_param);
                return;  
            }

          for(var i=0; i<this.groom_list.length; i++){

            if(this.groom_id == this.groom_list[i].groom_id && this.groom_list[i].admin_only == 1){
              const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                message: `해당 그룹룸은 예약전용 입니다.<br>관리자에게 문의하세요`,
                router: '',
                image_type: 'warning'
              };
              this.$store.commit('set_popup_type', alert_param);
              return;
            }
          }

          const type_groom_status_get = config.REQ_GROOM_STATUS_GET;
          if(parseInt(this.groom_id) > 0){
                this.$store.dispatch(type_groom_status_get.action_name, {
                    type: type_groom_status_get,
                    data: {groom_id: this.groom_id}
                }).then(response => {     
                    let sel_groom_status = response.data[0].reservation_status
                    //if(sel_groom_status == "GR_RESV_LOCK"){
                    // 모바일 어플 강제종료때문에 일단 빼자 
                    if(sel_groom_status == ""){
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `해당 그룹룸은 현재 예약 진행중입니다.<br>잠시 후 다시 시도해주세요.`,
                            router: '',
                            image_type: 'warning'
                        };
                        this.$store.commit('set_popup_type', alert_param);
                    }else{
                        if (this.groom_id.length == 0) {
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: `그룹룸을 선택해 주세요.`,
                                router: '',
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            return;
                        }
                        this.$store.commit('set_select_groom', {
                            groom_id: this.groom_id,
                            groom_name: this.groom_name,
                            groom_type_id: this.groom_type_id,
                            groom_seat_count: this.groom_seat_count,
                            min_user_count: this.min_user_count,
                            type_name : this.type_name,
                            groom_goods_group_id: this.groom_goods_group_id,
                            groom_goods_name: this.groom_goods_name,
                            selection_plan_code: this.selection_plan_code,
                            goods_group_name: this.goods_group_name,
                        });

                        var groom_info = {};
                            groom_info.groom_id = this.groom_id;
                            groom_info.before_groom_id = this.groom_id;
                            groom_info.groom_status_code = '';
                            groom_info.groom_name = this.groom_name;
                            groom_info.groom_info = this.groom_info;
                            groom_info.groom_seat_count = this.groom_seat_count;
                            groom_info.groom_type_id = this.groom_type_id;
                            groom_info.min_user_count = this.min_user_count;
                            groom_info.type_name = this.type_name;
                            groom_info.groom_goods_group_id = this.groom_goods_group_id;
                            groom_info.groom_goods_name = this.groom_goods_name;
                            groom_info.selection_plan_code = this.selection_plan_code;
                            groom_info.goods_group_name = this.goods_group_name;
                            this.$store.commit('set_main_page_tab_code', {
                                'tab_code': 'GROOM',
                                'groom_info': groom_info
                            });

                        this.$store.commit('change_main_tab_chk', {
                            value: 2
                        });
                        if (!this.$store.state.login_chk) {
                            // this.$router.push('/login');
                            this.$store.commit('set_Last_URL','/payment-group_room_reservation');
                        } else {
                            this.$router.push('/payment-group_room_reservation');
                        }
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
          }

        },
        step(val) {
            let z = 0;
            // 기존에 있던 그룹룸 데이터 셋 초기화
            this.groom_id = '';
            this.before_groom_id = '';
            this.type_name = '';
            this.groom_status_code = '';
            this.groom_name = '';
            this.groom_info = '';
            this.groom_seat_count = '';
            this.groom_type_id = '';
            this.min_user_count = '';

            this.add_step += val;
            let i = 0;

            for (i; i < this.groom_all_list.length; i++) {
                if (this.add_step == i) {
                    this.groom_list = this.groom_all_list[i].grooms;
                }
            }

            if (this.groom_all_list.length == this.add_step + 1) {
                this.wid_scroll_right = false;
            } else {
                this.wid_scroll_right = true;
            }
            if (this.add_step != 0) {
                this.wid_scroll_left = true;
            } else {
                this.wid_scroll_left = false;

            }

        },
        select_groom(g_data) {
            // 그룹룸 리스트에 있는 아이디 체크해서 css 변경
            for (let i = 0; i < this.groom_list.length; i++) {
                if (g_data.groom_id == this.groom_list[i].groom_id) {
                    this.groom_list[i].class = 'on';
                } else {
                    this.groom_list[i].class = 'over';
                }
            }
            // 그룹룸 클릭 하면 해당 그룹룸에 관련된 데이터 셋
            this.groom_id = g_data.groom_id;
            this.before_groom_id = this.groom_id;
            this.groom_status_code = g_data.groom_status_code;
            this.groom_name = g_data.groom_name;
            this.groom_info = g_data.groom_info;
            this.groom_seat_count = g_data.seat_count;
            this.groom_type_id = g_data.groom_type_id;
            this.min_user_count = g_data.min_user_count;
            // 새로추가
            this.type_name = g_data.type_name;
            this.groom_goods_group_id = g_data.groom_goods_group_id;
            this.groom_goods_name = g_data.groom_goods_name;
            this.selection_plan_code = g_data.selection_plan_code;
            this.goods_group_name = g_data.goods_group_name;
            this.sel_group_name = g_data.tab_name + " - " + g_data.groom_name;

            // 당일 예약현황
            this.get_reservation_list(this.groom_id);
            this.map_group_sel_pop = false;
        },
        convertDate(strDate){
            var convertDate = "";
            if(typeof strDate != "undefined"){
                var date = strDate.split(" ");
                convertDate = date[0];
            }
            return convertDate;
        },
        convertTime(strDate){
            var convertTime = "";
            if(typeof strDate != "undefined"){
                var time = strDate.split(" ");
                convertTime = time[1];
            }
            return convertTime;
        },
        get_reservation_list(groom_id){
            const reserv_type = config.REQ_GROOM_TODAY_RESERVATION_GET_LIST;
            this.$store.dispatch(reserv_type.action_name, {
                type: reserv_type,
                data: {'groom_id': groom_id}
            }).then(response => {
                this.today_groom_reserv_list = response.data;
                this.today_groom_using_list = response.data2;
                this.today_groom_reserv_list.index = this.today_groom_using_list.length;
            }).catch(function (error) {
                console.log('error=============>', error);
            });

            ++this.first_loading_groom_count;

            if (this.first_loading_groom_count == 1) {
                this.$emit("first_loading_groom");
            }
        },
        select_seat_map_group() {
            var group_id = this.map_group_id;
            this.loading = true;
            let self = this;
            this.render_map_group_id(group_id, (result) => {

                self.$refs.seat[0].refresh_from_main(500, (result) => {
                    self.loading = result;
                    var area = self.$refs.seatarea[0];
                    if ((area.scrollHeight == 0 && area.clientHeight == 0) || (area.scrollHeight > area.clientHeight)) {
                        self.fade_seat = true;
                        this._fade('seat');
                    } else if ((area.scrollWidth == 0 && area.clientWidth == 0) || (area.scrollWidth > area.clientWidth)) {
                        self.fade_seat = true;
                        this._fade('seat');
                    } else {
                        self.fade_seat = false;
                    }

                })
            })

        },
        groomOptionCheck(){
            console.log('a')
            const reserv_type = config.REQ_STORE_OPTION;
            this.$store.dispatch(reserv_type.action_name, {
                type: reserv_type,
                data: {'store_id':this.$store.getters['getStoreId']}
            }).then(response => {
                console.log( response.data)
                this.groom_reserve_use_yn = response.data.groom_reserve_use;
                this.groom_limit_now_use = response.data.groom_limit_now_use;
                this.groom_limit_now_start_time = response.data.groom_limit_now_start_time;
                this.groom_limit_now_end_time = response.data.groom_limit_now_end_time; 
            }).catch(function (error) {
                console.log('error=============>', error);
            });

        }

    },
    created: function () {

    },
    mounted() {
        this.$store.commit('set_page_header_init', {
            style: 'block'
        });
        var self = this;
        this.$nextTick(function () {
            this.groomOptionCheck();
            this.tab_data = this.$store.getters['get_map_group_list'];
            // 탭(층) 관련로직
            if (this.tab_data.length != 0) {
                var floor_index = 0;
                var floor_group = 1;
                for (let i = 0; i < this.tab_data.length; i++) {
                    if (this.tab_data[i].tab_name.length > 4) {
                        var slice_str = this.tab_data[i].tab_name.slice(0, 4);
                        this.tab_data[i].tab_name_main = slice_str + "..";
                    } else {
                        this.tab_data[i].tab_name_main = this.tab_data[i].tab_name;
                    }
                }

                this.tab_index = 0;
            }

            //그룹룸 리스트 갱신
            const type_groom_list = config.REQ_GROOM_GROUPROOM_GET_LIST;
            const data = {};

            data.groom_id = this.groom_id;
            this.$store.dispatch(type_groom_list.action_name, {
                type: type_groom_list,
                data: data
            }).then(response => {
                this.groom_all_list = response.data;

                this.groom_all_list_arr = new Array();
                var z = 0;

                for(let x = 0; x < this.tab_data.length; x++){

                    for(let i = 0; i < this.groom_all_list.length; i++){
                        if(this.groom_all_list[i].map_group_id == this.tab_data[x].map_group_id){
                            for(let j = 0; j < this.groom_all_list[i].grooms.length; j++ ){
                                this.groom_all_list_arr[z] = this.groom_all_list[i].grooms[j];
                                this.groom_all_list_arr[z].tab_name = this.tab_data[x].tab_name;
                                z++;
                            }
                        }
                    }
                }

                this.groom_list = this.groom_all_list_arr;

                for(let i = 0; i < this.groom_all_list[0].grooms.length; i ++){
                    if(this.groom_all_list[0].grooms[i].groom_status_code == "GROOM_CHANGE"){
                        this.groom_all_list[0].grooms.splice(i,1);
                    }
                }
               // this.groom_list = this.groom_all_list[0].grooms;

                if (this.groom_all_list.length > 1) {
                    this.wid_scroll_right = true;
                }
            }).then(() => {
                if(this.$store.getters.get_main_page_tab_code.main_page_code == "GROOM"){
                    var groom_info = this.$store.getters.get_main_page_tab_code.main_page_groom_info;
                    this.groom_id = groom_info.groom_id;
                    this.before_groom_id = groom_info.groom_id;
                    this.groom_status_code = groom_info.groom_status_code;
                    this.groom_name = groom_info.groom_name;
                    this.groom_info = groom_info.groom_info;
                    this.groom_seat_count = groom_info.groom_seat_count;
                    this.groom_type_id = groom_info.groom_type_id;
                    this.min_user_count = groom_info.min_user_count;
                    this.type_name = groom_info.type_name;
                    this.groom_goods_group_id = groom_info.groom_goods_group_id;
                    this.groom_goods_name = groom_info.groom_goods_name;
                    this.selection_plan_code = groom_info.selection_plan_code;
                    this.goods_group_name = groom_info.goods_group_name;
                    var g_data = this.groom_list[0];
                    for (let i = 0; i < this.groom_list.length; i++) {
                        if (groom_info.groom_id == this.groom_list[i].groom_id) {
                            this.groom_list[i].class = 'on';
                            this.sel_group_name = this.groom_list[i].tab_name + " - " + this.groom_list[i].groom_name
                        } else {
                            this.groom_list[i].class = 'over';
                        }
                    }
                    this.$store.commit('set_main_page_tab_code', {
                        'tab_code': '',
                        'groom_info' : {}
                    });
                }else{
                    if(this.groom_list.length != 0){
                        var g_data = this.groom_list[0];
                        //document.getElementById(g_data.groom_id).setAttribute("class","over");
                        this.groom_list[0].class = "on";
                        this.groom_id = g_data.groom_id;
                        this.before_groom_id = g_data.groom_id;
                        this.groom_status_code = g_data.groom_status_code;
                        this.groom_name = g_data.groom_name;
                        this.groom_info = g_data.groom_info;
                        this.groom_seat_count = g_data.seat_count;
                        this.groom_type_id = g_data.groom_type_id;
                        this.min_user_count = g_data.min_user_count;
                        this.type_name = g_data.type_name;
                        this.groom_goods_group_id = g_data.groom_goods_group_id;
                        this.groom_goods_name = g_data.groom_goods_name;
                        this.selection_plan_code = g_data.selection_plan_code;
                        this.goods_group_name = g_data.goods_group_name;
                        this.sel_group_name = g_data.tab_name + " - " + g_data.groom_name;
                    }
                }


                if(self.groom_id != '' || self.groom_id != undefined || self.groom_id != 'undefined' ){
                    this.get_reservation_list(self.groom_id);
                }
                ++this.first_loading_groom_count;

                if (this.first_loading_groom_count == 1) {
                    this.$emit("first_loading_groom");
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });

        });
    },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/components/group_room.vue